import { store } from '@redux/store';
import { filter, fromEvent } from "rxjs";
import { onArticleCountResultsLoaded$, articleSearchResultsActions } from 'features/articleSearchResultsFacets';

const pageSizeElement = document.querySelector('[data-page-size]');
const pageSizeChange$ = fromEvent(pageSizeElement, 'change');

/**
 * Updates the page size parameter in the Redux store when the page size dropdown changes.
 * @param {Event} event - The change event triggered by the page size dropdown.
 */
const updatePageSize = function(event) {
  const newPageSize = Number(event.target?.value || 40);
  store.dispatch(articleSearchResultsActions.updatePageSizeParameter(newPageSize));
};

/**
 * Resets the page size dropdown to its default value.
 */
const resetPageSizeComponent = function() {
  pageSizeElement.selectedIndex = 0;
};

/**
 * Observable that listens for new article count results and filters for counts greater than 20.
 * @type {Observable<number>}
 */
const newCountResults$ = onArticleCountResultsLoaded$.pipe(
  filter((countResults) => countResults > 20)
);

pageSizeChange$.subscribe(updatePageSize);
newCountResults$.subscribe(resetPageSizeComponent);